import React from 'react';
import PropTypes from 'prop-types';

import TourCardImage from 'app/shared/components/postingPath/TourCard/TourCardImage';
import TourCardDetails from 'app/shared/components/postingPath/TourCard/TourCardDetails';
import TourCardSelectableControls from 'app/shared/components/postingPath/TourCard/TourCardSelectableControls';
import TourCardContentContainer from 'app/shared/components/postingPath/TourCard/TourCardContentContainer';
import TourCardContainer from 'app/shared/components/postingPath/TourCard/TourCardContainer';

const propTypes = {
    tour: PropTypes.shape({
        name: PropTypes.string.isRequired,
        createdDate: PropTypes.string.isRequired,
        creatorName: PropTypes.string.isRequired,
        imageSrc: PropTypes.string,
        state: PropTypes.oneOf(['active', 'inactive', 'empty']),
    }).isRequired,
    isSelected: PropTypes.bool,
    onView: PropTypes.func.isRequired,
    onSelect: PropTypes.func.isRequired,
};

const defaultProps = {
    isSelected: false,
};

const TourCardSelectable = ({
    tour,
    isSelected,
    onView,
    onSelect,
}) => (
    <TourCardContainer
        isSelected={isSelected}
        hasBigBottomBorder={isSelected}
    >
        <TourCardImage
            imageSrc={tour.imageSrc}
            tourState={tour.state}
            isSelected={isSelected}
            onClick={onSelect}
        />
        <TourCardContentContainer>
            <TourCardDetails
                tour={tour}
            />
            <TourCardSelectableControls
                isSelected={isSelected}
                onView={onView}
                onSelect={onSelect}
            />
        </TourCardContentContainer>
    </TourCardContainer>
);

TourCardSelectable.propTypes = propTypes;
TourCardSelectable.defaultProps = defaultProps;

export default TourCardSelectable;
